import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-error-dialog',
    styleUrls: ['error-dialog.component.scss'],
    templateUrl: 'error-dialog.component.html'
})
export class ErrorDialogComponent {
    public errorMsgs: Array<string> = [];
    public btnText: string = 'OK';
    public isEditFailure: boolean = false;
    public titleText = 'Something went wrong';
    constructor(
        public dialogRef: MatDialogRef<ErrorDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        if (data.hasOwnProperty('errorMsg')) {
            if (Array.isArray(data.errorMsg)) {
                this.errorMsgs = data.errorMsg;
            }
        }

        if (data.hasOwnProperty('isEditFailure')) {
            this.isEditFailure = data.isEditFailure;
        }

        if (data.hasOwnProperty('titleText') && data.titleText) {
            this.titleText = data.titleText;
        }

        if (data.hasOwnProperty('btnText') && data.btnText) {
            this.btnText = data.btnText;
        }
    }

    onDialogClose() {
        this.dialogRef.close({});
    }
}
